import { useState, useEffect } from 'react';
import { fetchApi } from '../redux/api';

const useBankList = () => {
    const [bankList, setBankList] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchBanks = async () => {
            try {
                const response = await fetchApi('get-banklist');
                if (response && response.result) {
                    setBankList(response.result);
                }
            } catch (error) {
                console.error('Error fetching bank list:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchBanks();
    }, []);

    return { bankList, loading };
};

export default useBankList;
